import { Link } from "react-router-dom";

export default function EjercicioProfesional() {
  return (
    <section id="ejercicioprofesional" className="services section">
      <div className="container section-title fade-up">
        <h2>Ejercicio Profesional</h2>
        <p>
          Información y documentación necesaria para el ejercicio de la
          profesión en la Provincia de La Pampa.
        </p>
      </div>

      <div className="container mt-4">
        <div className="row gy-4">
          <div className="col-lg-4 col-md-6 fade-up">
            <div className="service-item position-relative">
              <div className="icon">
                <i className="bi bi-cash-coin"></i>
              </div>
              <a
                className="stretched-link"
                href="/assets/portal/docs/HONORARIOS_MINIMOS_ETICOS.pdf"
                target="_blank"
                rel="noopener noreferrer"
              >
                Honorarios Mínimos Éticos
              </a>
              <p>
                Descargue la tabla de honorarios mínimos éticos del año en
                curso.
              </p>
            </div>
          </div>

          <div className="col-lg-4 col-md-6 fade-up">
            <div className="service-item position-relative">
              <div className="icon">
                <i className="bi bi-award"></i>
              </div>
              <a
                className="stretched-link"
                href="/assets/portal/docs/CODIGO_DE_ETICA_COFOLP.pdf"
                target="_blank"
                rel="noopener noreferrer"
              >
                Código de Ética
              </a>
              <p>
                Descargue el Código de Ética Profesional vigente del Colegio.
              </p>
            </div>
          </div>

          <div className="col-lg-4 col-md-6 fade-up">
            <div className="service-item position-relative">
              <div className="icon">
                <i className="bi bi-patch-check"></i>
              </div>
              <Link className="stretched-link" to="../certificado-etica">
                Certificado de Ética
              </Link>
              <p>
                Solicite el certificado de ética profesional expedido por el
                Colegio.
              </p>
            </div>
          </div>

          <div className="col-lg-4 col-md-6 fade-up">
            <div className="service-item position-relative">
              <div className="icon">
                <i className="bi bi-file-earmark-text"></i>
              </div>
              <a
                className="stretched-link"
                href="/assets/portal/docs/CONSENTIMIENTO_INFORMADO_COFOLP.pdf"
                target="_blank"
                rel="noopener noreferrer"
              >
                Consentimiento Informado
              </a>
              <p>
                Descargue el modelo de consentimiento informado para uso en
                consultorio.
              </p>
            </div>
          </div>

          <div className="col-lg-4 col-md-6 fade-up">
            <div className="service-item position-relative">
              <div className="icon">
                <i className="bi bi-building-check"></i>
              </div>
              <Link className="stretched-link" to="../consultorio">
                Habilitación del Consultorio
              </Link>
              <p>
                Revise la documentación necesaria para habilitar su consultorio
                privado.
              </p>
            </div>
          </div>

          <div className="col-lg-4 col-md-6 fade-up">
            <div className="service-item position-relative">
              <div className="icon">
                <i className="bi bi-person-badge"></i>
              </div>
              <Link className="stretched-link" to="../matriculacion">
                Matriculación
              </Link>
              <p>
                Lea atentamente los requisitos para incorporarse como
                profesional matriculado.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
